module.exports = __webpack_public_path__ + "img/1701396034867-WhatsApp Image 2023-12-01 at 10.00.01.jpeg.dabf1485.webp";